export const navigation = {
  data() {
    return {};
  },
  methods: {
    decNext: function () {
      let k = 0;
      if (this.active_key > 0) {
        k = this.active_key - 1;
      } else {
        k = 0;
      }

      this.$emit("setProp", { prop: "active_key", value: k });
    },
    incNext: function () {
      let k = 0;
      if (this.active_key == 2 && [2, 3].indexOf(this.health_bracket) == -1) {
        k = this.active_key + 2;
      } else if (this.active_key < this.active_index.length - 1) {
        k = this.active_key + 1;
      } else {
        k = this.active_index.length - 1;
      }
      this.$emit("setProp", { prop: "active_key", value: k });
    },
    goto: function (url) {
      return (window.location = url);
    },
  },
};
